import styled from 'styled-components'

export const GridBreak = styled.div`
  width: 100%
`;